import { useSelector } from "react-redux";

// The logged-in user's own (root) account — unlike useAccount() (the `accountGet`
// slice, which reflects whichever org is currently being viewed and gets reset +
// re-fetched on CURRENT_CHILD_ORGANIZATION_SET), this is never re-scoped to a child.
// Billing is parent-consolidated for MSPs, so billing-visibility checks should read
// planId/subscriptionStatus from here, not from useAccount(). See rootAccountGetSaga.js.
export function useRootAccount() {
  return useSelector((s) => s.rootAccountGet);
}
